import { Handler } from "../types/store-types";
import {
    AddMessageActionType,
    ChatActionTypes,
    IChatState,
    SendMessageFailureActionType,
    SendMessageRequestActionType,
    SendMessageSuccessActionType,
    ToggleChatBotActionType,
} from "./types";

const toggleChat: Handler<IChatState, ToggleChatBotActionType> = (state, { payload }) => {
    return { ...state, isOpen: payload.isOpen };
};

const addMessage: Handler<IChatState, AddMessageActionType> = (state, { payload }) => {
    const message = {
        id: Date.now().toString(),
        role: "user" as const,
        content: payload.message,
        timestamp: Date.now(),
    };
    return { ...state, messages: [...state.messages, message] };
};

const sendMessageRequest: Handler<IChatState, SendMessageRequestActionType> = (state, { payload }) => {
    return { ...state, loading: true, error: null };
};

const sendMessageSuccess: Handler<IChatState, SendMessageSuccessActionType> = (state, { payload }) => {
    const message = {
        id: Date.now().toString(),
        role: "OpenAi" as const,
        content: payload.answer,
        timestamp: Date.now(),
    };
    return { ...state, messages: [...state.messages, message], loading: false };
};

const sendMessageFailure: Handler<IChatState, SendMessageFailureActionType> = (state, { payload }) => {
    const { data } = payload;
    return { ...state, error: data, loading: false };
};

export const chatHandlers = {
    [ChatActionTypes.TOGGLE_CHAT]: toggleChat,
    [ChatActionTypes.ADD_MESSAGE]: addMessage,
    [ChatActionTypes.SEND_MESSAGE_REQUEST]: sendMessageRequest,
    [ChatActionTypes.SEND_MESSAGE_SUCCESS]: sendMessageSuccess,
    [ChatActionTypes.SEND_MESSAGE_FAILURE]: sendMessageFailure,
};
